/* eslint-disable */
import Vue from 'vue'
import moment from 'moment'
import { money } from '@/utils/filters'
import variables from '@/utils/variables'
import { RECEIPT_PRODUCT_SAMPLE } from '@/utils/types/receipt-product'
import receiptService from '@/services/receipts'
import _ from 'lodash'

export function getReceiptCss () {
  return `
  body {
    font-size: 12px;
  }

  table {
    border-collapse: collapse; 
  }

  table thead tr {
    border-bottom: 1px solid black;
    border-top: 1px solid black;
    font-weight: bold;
    padding-bottom: 2px;
    padding-top: 2px;
  }

  .bar {
    border-bottom: 1px solid black;
    border-top: 1px solid black;
    padding-bottom: 2px;
    padding-top: 2px;
  }

  .text-xs-left {
    text-align: left;
  }

  .text-xs-center {
    text-align: center;
  }

  .text-xs-right {
    text-align: right;
  }

  .font-size-xs {
    font-size: 10px;
  }
    
  .font-size-sm {
    font-size: 11px;
  }

  .font-size-md {
    font-size: 12px;
  }

  .font-size-lg {
    font-size: 13px;
  }

  .font-weight-bold {
    font-weight: bold;
  }

  .text-uppercase {
    text-transform: uppercase;
  }
`
}

export function getReceiptLogo (receipt) {
  const storeLogoUrl = _.get(receipt, 'store.storeReceiptLogoUrl') || `${variables.baseUrl}/static/images/vaporshop-logo-receipt.jpg`
  const logo = [
    `\x1B\x61\x31`, // center align
    {
      type: 'raw',
      format: 'image',
      data: storeLogoUrl,
      options: {
        language: 'ESCPOS',
        dotDensity: 'double'
      }
    }
  ]

  return logo
}

export function getReceiptContent (receipt) {
  return receiptService.getPrintHtml(receipt.uuid)
    .then(html => 
      Promise.resolve([{
        type: 'pixel',
        format: 'html',
        flavor: 'plain',
        data: html
      }])
    )
    .catch(err => Promise.reject(err))
}

export function getReceiptHtml (receipt) {
  // filter out sample rows
  if (!receipt.store.showSamplesOnReceipt) {
    receipt.receiptProducts = receipt.receiptProducts.filter(item => item.saleType !== RECEIPT_PRODUCT_SAMPLE)
  }
  const html = /*html*/`
    <html>
      <style>
        ${getReceiptCss()}
      </style>

      <div class="bar font-size-md font-weight-bold text-xs-center text-uppercase">
        ${Vue.i18n.translateIn(receipt.language, 'Receipt')}
      </div>

      <table width="100%" class="font-size-sm">
        <tr>
          <td class="font-weight-bold">${Vue.i18n.translateIn(receipt.language, 'Unique nr.')}:</td>
          <td>${receipt.nr}</td>
        </tr>
        <tr>
          <td class="font-weight-bold">${Vue.i18n.translateIn(receipt.language, 'Date')}:</td>
          <td>${moment(receipt.completed).format('D MMMM YYYY')}</td>
        </tr>
        <tr>
          <td class="font-weight-bold">${Vue.i18n.translateIn(receipt.language, 'Time')}:</td>
          <td>${moment(receipt.completed).format('HH:mm')}</td>
        </tr>
      </table>

      <table width="100%">
        <colgroup>
          <col width="20%">
          <col width="50%">
          <col width="15%">
          <col width="15%">
        </colgroup>
        <thead class="font-size-md">
        <tr>
          <th class="text-xs-left">${Vue.i18n.translateIn(receipt.language, 'Artnr.')}</th>
          <th class="text-xs-left">${Vue.i18n.translateIn(receipt.language, 'Description')}</th>
          <th class="text-xs-right">${Vue.i18n.translateIn(receipt.language, 'Price')}</th>
          <th class="text-xs-right">${Vue.i18n.translateIn(receipt.language, 'Total')}</th>
        </tr>
        </thead>
        <tbody class="font-size-sm">
          ${Object.keys(receipt.receiptProducts).map(key => (
            `
            <tr>
              <td>                
              ${receipt.receiptProducts[key].barcode || `&lt;${Vue.i18n.translateIn(receipt.language, 'None')}&gt;`}
              </td>
              <td colspan="3">
                <table width="100%">
                  <colgroup>
                    <col width="62.50%">
                    <col width="18.75%">
                    <col width="18.75%">
                  </colgroup>
                  <tbody class="font-size-sm">
                    <tr>
                      <td colspan="3">${receipt.receiptProducts[key].display}</td>
                    </tr>
                    <tr>
                      <td>${receipt.receiptProducts[key].qty}x</td>
                      <td class="text-xs-right">${money(receipt.receiptProducts[key].priceInclVat)}</td>
                      <td class="text-xs-right">${money(receipt.receiptProducts[key].totalInclVat)}</td>
                    </tr>
                  </tbody>
                </table>                
              </td>
            </tr>
            `)).join('')}
        </tbody>
        <tfoot class="font-size-md">
          <tr><td><br></td></tr>
          <tr>
            <td></td>
            <td>${Vue.i18n.translateIn(receipt.language, 'Subtotal')}</td>
            <td colspan="2" class="text-xs-right">${money(receipt.totalProductsInclVat)}</td>
          </tr>
          ${receipt.store.showDiscountOnReceipt && receipt.totalReceiptDiscountInclVat > 0 ? 
          /*html*/`
          <tr>
            <td></td>
            <td>${Vue.i18n.translateIn(receipt.language, 'Discount')}</td>
            <td colspan="2" class="text-xs-right">${money(receipt.totalReceiptDiscountInclVat)}</td>
          </tr>` : ''}
          <tr>
            <td></td>
            <td>${Vue.i18n.translateIn(receipt.language, 'Total')}</td>
            <td colspan="2" class="text-xs-right">${money(receipt.totalInclVat)}</td>
          </tr>
          <tr>
            <td></td>
            <td class="font-weight-bold">${Vue.i18n.translateIn(receipt.language, 'Total')} (${Vue.i18n.translateIn(receipt.language, 'Rounded').toLowerCase()})</td>
            <td colspan="2" class="font-weight-bold text-xs-right">${money(receipt.totalInclVatRounded)}</td>
          </tr>     
          <tr>
            <td></td>
            <td>${Vue.i18n.translateIn(receipt.language, 'VAT')} ${receipt.vat}%</td>
            <td colspan="2" class="text-xs-right">${money(receipt.totalVat)}</td>
          </tr>
          ${Object.keys(receipt.transactions).map(key => (
            /*html*/`
            <tr>
              <td></td>
              <td>${receipt.transactions[key].isRefund ? Vue.i18n.translateIn(receipt.language, 'Refund') : receipt.transactions[key].paymentMethod.name}</td>
              <td colspan="2" class="text-xs-right">${money(receipt.transactions[key].totalInclVat)}</td>
            </tr>
            `
  )).join('')}
        </tfoot>
      </table>

      <p class="text-xs-right">
        ${Vue.i18n.translateIn(receipt.language, 'Number of {0}', [Vue.i18n.translateIn(receipt.language, 'Articles').toLowerCase()])}: ${getItemCount(receipt)}
      </p>

      ${receipt.note ? /*html*/`
      <p class="text-xs-right">${receipt.note}</p>` : ''}

      ${receipt.creator ? /*html*/`
      <p class="text-xs-center font-weight-bold">
        ${Vue.i18n.translateIn(receipt.language, 'You were helped by {0}', [receipt.creator.screenName])}
      </p>` : ''}

      <div class="text-xs-center font-size-xs">
        <p>${Vue.i18n.translateIn(receipt.language, 'Thank you for your purchase at {0}!', [receipt.store.name || 'Vaporshop'])}</p>
        ${receipt.store.businessName && receipt.store.businessNr ? /*html*/`
        <span>${receipt.store.businessName} | ${receipt.store.businessNr} <br/></span>` : ''}

        ${receipt.store.email ? /*html*/`
          <span>${receipt.store.email} |</span>` : ''}

        ${receipt.store.phone ? /*html*/`
          <span>${receipt.store.phone}</span>` : ''}

        ${receipt.store.receiptText ? /*html*/`
          <p>${receipt.store.receiptText.replace(/\n/g, "<br>")}</p>` : ''}
      </div>
    </html>`

  return [{
    type: 'pixel',
    format: 'html',
    flavor: 'plain',
    data: html
  }]
}

export function getReceiptQR(receipt) {
  const qr = receipt.nr

  // QR Dot Size
  const dots = `\x05`
  // QR proprietary size calculation
  const size1 = String.fromCharCode(receipt.nr.length + 3)
  const size0 = `\x00`

  // Create the QR Code
  return [
    `\x1B\x61\x31`, // center align
    // <!-- BEGIN QR DATA -->
    `\x1D\x28\x6B\x04\x00\x31\x41\x32\x00`,
    `\x1D\x28\x6B\x03\x00\x31\x43${dots}`,
    `\x1D\x28\x6B\x03\x00\x31\x45\x30`,
    `\x1D\x28\x6B${size1}${size0}\x31\x50\x30${qr}`,
    `\x1D\x28\x6B\x03\x00\x31\x51\x30`,
    `\x1D\x28\x6B\x03\x00\x31\x52\x30`
    // <!-- END QR DATA -->
  ]
}

export function getItemCount(receipt) {
  return receipt.receiptProducts.reduce(function (accumulator, receiptProduct) {
    return accumulator + receiptProduct.qty
  }, 0)
}



// WEBPACK FOOTER //
// ./src/utils/receipt-layout.js